export default __webpack_public_path__ + "static/media/pepup.5d5517ec.png";